$(document).ready(function() {



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function(e){
        window.location = $(this).attr("href");
        return false;
    }).click(function(){
        window.location = $(this).find("a.js-click-item-link").attr("href");
        return false;
    });​




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page
    // *
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                scrollTo(target);
            return false;
            }
        }
    });

    function scrollTo(element) {
        $('html, body').animate({
            scrollTop: element.offset().top - 60
        }, 1000);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * slider
    // *
    // *
    var $slider = $(".js-slider");

    if ($slider.length){
        $slider.slick({
            fade: false,
            dots: false,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 8000,
            responsive: [],
            pauseOnHover: false,
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var color = $slider.find('.js-slider-item[data-slick-index= ' + nextSlide + ']').data("color");
            $(".js-slider-scrollto").removeClass("invert regular").addClass(color);
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navMobile
    // *
    // *
    $(".js-nav-mobile-button, [data-nav-mobile-link]").click(function(){
        $(".js-nav-mobile-button, .js-nav-mobile").toggleClass("active");
        $("html, body").toggleClass("freeze");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * overlayContent
    // *
    // *
    $("[data-overlay-content]").click(function(){
        var id = $(this).data("overlay-content");
        $("#" + id).fadeIn();
        $("html, body").addClass("freeze");
    });

    $(".js-overlay-content-close").click(function(){
        $(".js-overlay-content").fadeOut();
        $("html, body").removeClass("freeze");
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * fadeawayLanguage
	// *
	// *
	$(window).scroll(function() {
		if($(window).scrollTop() >= 40) {
			$(".js-language").addClass("hidden");
		}else {
			$(".js-language").removeClass("hidden");
		}
	});


});
